module.exports = __webpack_public_path__ + "static/media/homePlate2Icon1.949c47c0.png";